import { RouteConfig } from 'vue-router'
import ListView from '../views/ListView.vue'
import ReadView from '../views/ReadView.vue'
import WriteView from '../views/WriteView.vue'
import RecommendView from '../views/RecommendView.vue'
const Board = () => import(/* webpackChunkName: "board" */ '@board/Index.vue')
const BoardMaster = () => import(/* webpackChunkName: "board" */ '@board/views/Master.vue')

const routes: RouteConfig[] = [
  {
    path: '/board',
    component: Board,
    children: [
      {
        path: '',
        component: BoardMaster,
        children: [
          {
            path: 'list',
            name: 'board-list',
            component: ListView,
          },
          {
            path: 'read',
            name: 'board-read',
            component: ReadView,
          },
          {
            path: 'write',
            name: 'board-write',
            component: WriteView,
          },
          {
            path: 'recommend',
            name: 'board-recommend',
            component: RecommendView,
          },
        ],
      },
    ],
  },
]
export default routes
